import type { IngestionDatasetProgress } from '../api/types.ts';
import { datasetMessageDisplayName } from './datasetDisplayName.ts';

export type DatasetStatus = 'completed' | 'syncing' | 'pending' | 'error';

const statusLabels: Record<DatasetStatus, string> = {
  completed: 'Up to date',
  syncing: 'Syncing',
  pending: 'Waiting',
  error: 'Error',
};

/** Connector-independent presentation; diagnostic text never determines status. */
export function ingestionDatasetDisplay(
  dataset: IngestionDatasetProgress,
  cancelled: boolean,
  labels: ReadonlyMap<string, string>,
) {
  let status: DatasetStatus;
  if (cancelled && dataset.stage !== 'done') status = 'pending';
  else if (dataset.stage === 'done') status = 'completed';
  else if (dataset.stage === 'error') status = 'error';
  else if (dataset.stage === 'pending') status = 'pending';
  else status = 'syncing';

  const message = dataset.error || dataset.message;
  const detail = datasetMessageDisplayName(
    message?.replace(/^Entity\s+'[^']+'\s*:\s*/i, ''), labels,
  );
  const syncedRows = dataset.synced_row_count;
  return {
    status,
    label: statusLabels[status],
    detail,
    errorDetail: dataset.error || status === 'error' ? detail : undefined,
    columns: dataset.column_count == null ? '—' : dataset.column_count.toLocaleString(),
    lastSync: status === 'completed' && !dataset.error && syncedRows != null
      && Number.isSafeInteger(syncedRows) && syncedRows > 0
      ? `Last sync: ${syncedRows.toLocaleString()} rows` : undefined,
  };
}